import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min'
import axios from 'axios'
import router from './router'

Vue.prototype.$axios = axios
Vue.config.productionTip = false


// 全局路由守卫：核心逻辑
router.beforeEach((to, from, next) => {
  // 如果要去需要密码的页面
  if (to.meta.needPassword) {
    if (sessionStorage.getItem('gate_ok') === '1') {
      // 已验证通过，放行
      next()
    } else {
      // 未验证，跳转到 gate，并带上原本想去的路径（方便验证成功后跳回去）
      next({
        path: '/x9k2p-gate-7m4q',
      })
    }
  } else {
    // 不需要密码的页面正常访问
    next()
  }
})


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
